// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icons-kit .icon{font-size:48px;min-width:70px}.btn{width:60px;padding:12px;height:auto;min-height:auto;font-size:12px;min-width:120px}", ""]);
// Exports
module.exports = exports;
